/* ZONLIDOOG: flechas ligeras; también funciona con desplazamiento táctil nativo. */
if(!window.__zdRelatedButtonsInstalled){
  window.__zdRelatedButtonsInstalled=true;
  document.addEventListener('click',function(event){
    const button=event.target.closest('[data-zd-related-step]');
    if(!button)return;
    const rail=document.getElementById(button.getAttribute('aria-controls'));
    const direction=Number(button.getAttribute('data-zd-related-step'));
    if(!rail||(direction!==1&&direction!==-1))return;
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({left:direction*Math.max(200,rail.clientWidth*.90),behavior:reduce?'auto':'smooth'});
  });
}